import { ApiError } from '@wundo/client/api.ts';
import type { JourneyFormErrors, JourneyFormField } from '@wundo/ui';
import { apiErrorMessage } from '@/lib/apiErrorMessage.ts';
import { runningJourneyIdOf } from '@/lib/journeys.ts';
import { refusalIssueMessage } from './refusalIssueMessage.ts';

export interface JourneyRefusal {
  errors: JourneyFormErrors;
  formError?: string;
}

const FIELDS = new Set<string>([
  'journey_type_id',
  'manager_user_id',
  'employee_email',
  'employee_name',
  'start_date',
]);

/**
 * A refused create as the journey form shows it. A running journey for the
 * same pair lands on the employee field with a way to it; schema refusals
 * under their field; anything else as one line. Build it once per failure.
 */
export function journeyRefusal(failure: unknown): JourneyRefusal {
  const runningJourneyId = runningJourneyIdOf(failure);
  if (runningJourneyId !== null) {
    return { errors: { running_journey_id: runningJourneyId } };
  }

  const errors: JourneyFormErrors = {};
  let unplaced = false;

  const issues = failure instanceof ApiError ? failure.issues : [];
  for (const issue of issues) {
    if (FIELDS.has(issue.path)) {
      errors[issue.path as JourneyFormField] = refusalIssueMessage(issue);
    } else {
      unplaced = true;
    }
  }

  if (Object.keys(errors).length > 0 && !unplaced) return { errors };
  return { errors, formError: apiErrorMessage(failure, 'Failed to create the journey') };
}
